export default __webpack_public_path__ + "static/media/Bonus_History_Legacy_Plus.6d1cceab.pdf";